/* global axios */
import ApiClient from '../ApiClient';

class DialerAPI extends ApiClient {
  constructor() {
    super('campaigns', { accountScoped: true });
  }

  state(campaignId) {
    return axios.get(`${this.url}/${campaignId}/dialer`);
  }

  join(campaignId) {
    return axios.post(`${this.url}/${campaignId}/dialer/join`);
  }

  // `pause` is a break the agent means to come back from, written down as such.
  leave(campaignId, { pause } = {}) {
    return axios.post(`${this.url}/${campaignId}/dialer/leave`, { pause });
  }

  heartbeat(campaignId) {
    return axios.post(`${this.url}/${campaignId}/dialer/heartbeat`);
  }

  rebuild(campaignId) {
    return axios.post(`${this.url}/${campaignId}/dialer/rebuild`);
  }

  queue(campaignId, { page = 1, status, q } = {}) {
    return axios.get(`${this.url}/${campaignId}/dialer/queue`, {
      params: { page, status, q },
    });
  }

  // One number or a whole list: the endpoint answers for each one on its own.
  addToQueue(campaignId, { phoneNumber, name, contacts }) {
    return axios.post(`${this.url}/${campaignId}/dialer/add_to_queue`, {
      phone_number: phoneNumber,
      name,
      contacts,
    });
  }

  // What a period adds up to: the calls, how long each step took, each agent's time and the errors.
  metrics(campaignId, period) {
    return axios.get(`${this.url}/${campaignId}/dialer/metrics`, {
      params: { period },
    });
  }

  // Every step the dialer took, newest first - all of them, one kind, or one contact's calls.
  events(campaignId, { page = 1, kind, taskId } = {}) {
    return axios.get(`${this.url}/${campaignId}/dialer/events`, {
      params: { page, kind, task_id: taskId },
    });
  }

  removeFromQueue(campaignId, taskId) {
    return axios.post(`${this.url}/${campaignId}/dialer/remove_from_queue`, {
      task_id: taskId,
    });
  }
}

export default new DialerAPI();
